import { render, staticRenderFns } from "./ContactsEditOverviewModal.vue?vue&type=template&id=0d5f64ea&scoped=true&"
import script from "./ContactsEditOverviewModal.vue?vue&type=script&lang=js&"
export * from "./ContactsEditOverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactsEditOverviewModal.vue?vue&type=style&index=0&id=0d5f64ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f64ea",
  null
  
)

export default component.exports